import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { FILE_TTL_OPTIONS, FileTtl } from '@/hooks/useFiles';

const TTL_LABELS: Record<FileTtl, string> = {
  '7d': '7 days',
  '14d': '14 days',
  '30d': '30 days',
  '90d': '90 days',
};

// Radix Select can't represent "no value" as an item value, so "keep
// forever" gets a sentinel that maps back to undefined.
const NEVER = 'never';

interface FileTtlSelectProps {
  value: FileTtl | undefined;
  onChange: (ttl: FileTtl | undefined) => void;
  className?: string;
}

/**
 * Retention picker for file uploads. The duration options mirror the
 * backend's fixed TTL enum (S3 lifecycle rules are static, so arbitrary
 * durations aren't supported); "Keep forever" uploads without expiry.
 */
export const FileTtlSelect: React.FC<FileTtlSelectProps> = ({
  value,
  onChange,
  className,
}) => (
  <Select
    value={value ?? NEVER}
    onValueChange={v => onChange(v === NEVER ? undefined : (v as FileTtl))}
  >
    <SelectTrigger className={className} aria-label="Auto-delete">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={NEVER}>Keep forever</SelectItem>
      {FILE_TTL_OPTIONS.map(ttl => (
        <SelectItem key={ttl} value={ttl}>
          Delete after {TTL_LABELS[ttl]}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
